import React, { Component } from 'react';

import AddressChangeTracker from '../../../../../Shared/React/js/components/addressSearch/AddressChangeTracker';
import DataSlider from './DataSlider';
import FilterModal from './modal/FilterModal';
import ShowFiltersButton from './ShowFiltersButton';
import ShowFiltersButtonSm from './ShowFiltersButtonSm';
import SpendSlider from './SpendSlider';
import TabletSelector from './TabletSelector';

export default class Filters extends Component {
    constructor(props) {
        super(props);
        this.ModalOpenEventName = 'Filters.OpenModal';
        this.onAddressChanged = this.onAddressChanged.bind(this);
        this.showModal = this.showModal.bind(this);
        this.retry = this.retry.bind(this);
        this.onScrollToTopClick = this.onScrollToTopClick.bind(this);
        this.onModalHidden = this.onModalHidden.bind(this);
        this.onModalOpenEventHandler = this.onModalOpenEventHandler.bind(this);

        this.state = {
            isModalActive: false
        };
    }

    onAddressChanged(value) {
        this.props.actions.changeAddress(value);
    }

    showModal() {
        this.setState(
            {
                isModalActive: true
            },
            () => {
                this.props.actions.showModal();
            }
        );
    }

    retry() {
        const modal = wo$('#modal-error');
        modal.modal('hide');
        wo$('body').removeClass('modal-open');
        wo$('.modal-backdrop').remove();

        this.props.actions.search();
    }

    getBoundingClientRect(elementId) {
        const element = wo$(`#${elementId}`)[0];
        return element ? element.getBoundingClientRect() : {};
    }

    onScrollToTopClick(e) {
        e.preventDefault();
        this.scrollToTop();
    }

    scrollToTop(selector = '.navbar') {
        if (!wo$ || wo$ === undefined) {
            return;
        }

        WhistleOut.scrollTo(selector);
    }

    onModalHidden() {
        this.setState({
            isModalActive: false
        });
    }

    onModalOpenEventHandler() {
        this.showModal();
    }

    componentDidMount() {
        wo$('body').on(this.ModalOpenEventName, this.onModalOpenEventHandler);
    }

    componentWillUnmount() {
        wo$('body').off(this.ModalOpenEventName, this.onModalOpenEventHandler);
    }

    render() {
        const dataSlider = (
            <DataSlider
                {...this.props.dataSlider}
                current={this.props.criteria.minimumData}
                actions={this.props.actions}
            />
        );
        const spendSlider = (
            <SpendSlider
                {...this.props.spendSlider}
                maxValue={this.props.criteria.common.maximumSpend}
                minValue={this.props.criteria.common.minimumSpend}
                actions={this.props.actions}
            />
        );
        const tabletSelector = (
            <TabletSelector
                {...this.props.tabletSelector}
                resources={this.props.resources}
                criteria={this.props.criteria}
                actions={this.props.actions}
            />
        );

        return (
            <React.Fragment>
                <AddressChangeTracker
                    onAddressChange={this.onAddressChanged}
                    initialValue={this.props.criteria.common.address}
                />
                <FilterModal
                    {...this.props}
                    key={`filters-${this.props.modal.isOpen}`}
                    onModalHidden={this.onModalHidden}
                />
                {
                    <div className="row pad-t-3 pad-y-0-xs sep-b-1-xs">
                        <div className="[ col-xs-24 ]">
                            <div className="row">
                                <div className="[ col-sm-10 ] [ col-md-8 ] [ pad-t-3 ]">{tabletSelector}</div>
                                <div className="[ col-sm-14 ] [ col-md-16 ] [ hidden-xs ]">
                                    <div className="display-flex align-items-flex-end flex-wrap-nowrap">
                                        <div className="[ col-sm-9 ] [ text-center pad-y-4 ]">
                                            <div className="pad-x-2">
                                                <div
                                                    className="font-4 font-3-sm text-muted line-height-12 pad-y-2 hover-bg"
                                                    data-container="body"
                                                    data-toggle="popover"
                                                    data-placement="top"
                                                    data-content={this.props.dataTooltip}
                                                    data-original-title=""
                                                    title=""
                                                >
                                                    {' '}
                                                    {this.props.resources.data} <i className="fa fa-info-circle" />{' '}
                                                </div>
                                                {dataSlider}
                                            </div>
                                        </div>
                                        <div className="[ col-sm-9 ] [ text-center pad-y-4 ]">
                                            <div className="pad-x-2">
                                                <div
                                                    className="font-4 font-3-sm text-muted line-height-12 pad-y-2 hover-bg"
                                                    data-container="body"
                                                    data-toggle="popover"
                                                    data-placement="top"
                                                    data-content={this.props.spendTooltip}
                                                    data-original-title=""
                                                    title=""
                                                >
                                                    {' '}
                                                    {this.props.resources.priceRange}{' '}
                                                    <i className="fa fa-info-circle" />{' '}
                                                </div>
                                                {spendSlider}
                                            </div>
                                        </div>
                                        <div className="[ col-sm-6 ] [ col-lg-6 ] [ text-center pad-y-4 ] filters-3">
                                            {this.props.showAllFilters ? (
                                                <>
                                                    <ShowFiltersButton
                                                        title={this.props.resources.filters}
                                                        onClick={this.showModal}
                                                    />
                                                    <ShowFiltersButtonSm
                                                        title={this.props.resources.moreFilters}
                                                        onClick={this.showModal}
                                                    />
                                                </>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div
                    className="modal fade"
                    id="modal-error"
                    data-backdrop="static"
                    data-keyboard="false"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-body [ pad-x-6  pad-y-12 ]">
                                <div className="row">
                                    <div className="col-xs-24 col-sm-15 col-sm-offset-6 col-lg-14 col-log-offset-2">
                                        <div className="text-center">
                                            <h2 className="font-7 mar-t-0 mar-t-5-xs">
                                                <strong>{this.props.resources.errorUpdatingResults}</strong>{' '}
                                                <span className="text-nowrap">
                                                    {this.props.resources.pleaseTryAgain}
                                                </span>
                                            </h2>
                                            <div className="pad-t-3 font-400" id="enterAddressLocationForm">
                                                <div className="row">
                                                    <div className="text-center-xs">
                                                        <button
                                                            onClick={this.retry}
                                                            type="button"
                                                            className="btn btn-primary"
                                                        >
                                                            {this.props.resources.retry}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
